module.exports = __webpack_public_path__ + "img/sparkle-2.850a8d74.svg";